//import jQuery from 'jquery';
import { gsap } from "gsap";

export default class VideoUi {


	constructor(mouse) {

		this.animatedIn = false;
		this.animatedOut = false;
		this.videoPlaying = false;
		this.useScrollTrigger = true;

		this.currentTime = 0;
		this.videoDuration = 0;
		this.timeRemaining = 0;

		this.sceneElemName = 'VIDEO_CONTAINER';
		this.sceneDuration = '100%';
		this.sceneOffset = 0;
		
		this.domElem = document.body.querySelector('#container-showreel-homepage');
		

		if( !this.domElem ) {
			console.error('DOM VIDEO NOT FOUND');
			return;
		}

		
		this.domVideoContainer = document.body.querySelector('.cursor-interactive-video');

		if( !this.domVideoContainer || this.domVideoContainer.length < 0) {
			console.error('DOM VIDEO CONTAINER ELEM NOT FOUND');
			return;
		}

		this.domVideoElem = this.domVideoContainer.querySelector('video');

		this.dimensions = this.domVideoContainer.getBoundingClientRect();

		//this.createSlash();

		this.initTimeline();
		this.defaultTween();

		console.warn("[VideoUi.js] loaded");

		this.domVideoMouse = mouse;
		if( !this.domVideoMouse || this.domVideoMouse.length < 0) {
			console.error('DOM VIDEO MOUSE ELEM NOT FOUND');
			return;
		} else {
			this.videoDuration = this.domVideoElem.duration;
			this.initMouseEvents();
		}

		return this.timeline;
		
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 0,
			defaults: {
				//ease: "power3",
				ease: "power1.inOut"
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("VideoUi.js finished");
			},
		});
	}

	scrollTriggerOptions() {

		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			//start: 'top center', // when the top of the trigger hits the top of the viewport
			start: 'center center',
			end: 'bottom top',
			//end: `+=${this.dimensions.height}`,
			scrub: 1,
			//once: true,
			onToggle: (self) => {

				//console.info(`${this.sceneElemName} active:`, self.isActive)

				if( self.isActive === true ) {

					this.createVideoTextMouse();

					//console.info('VIDEO ENTERED VIEWPORT');

					if (document.fullscreenElement) {} else {
						if (this.domVideoElem.paused) {
							this.domVideoElem.muted = true;
							this.domVideoElem.play();
						}
					}
				} else if( self.isActive === false ) {
					if( this.domVideoElem ) {
						//this.domVideoElem.pause();
						//this.videoPlaying = false;
						//console.info('VIDEO LEFT VIEWPORT');

						if (!this.domVideoElem.paused) {
							//this.domVideoElem.pause();
							this.domVideoElem.muted = true;
						}
						
					}
				}
			}
		}

	}

	createSlash() {

		let htmlSlashElem = document.createElement("div");
		htmlSlashElem.className = "c-scene-slash c-scene-slash--black c-scene-slash--full";

		const videoContainer = document.querySelector('.e-hosted-video');

		if( videoContainer ) {
			videoContainer.prepend(htmlSlashElem);
		}
	}

	defaultTween() {

		return this.timeline
		.fromTo(
			this.domElem.querySelector('.c-scene-slash'), 
			{
				maxWidth: '100%',
				backgroundColor: '#000000',
				scaleX: 1.5,
				x: '-55%',
			},
			{
				x: '-55%',
				maxWidth: '0%',
				scaleX: 1,
				backgroundColor: '#FECC00',
				overwrite: false,
				//ease: "power1.inOut"
				//immediateRender: false,
				//ease: Power0.easeInOut
				//ease: Power0.easeOut
			},
			'-=.95'
		)
	}

	createVideoTextMouse() {

		const doesExist = document.body.querySelector('.textest');
		if( doesExist ) {
			return;
		}

		let mouseCursorContainerText = document.createElement("div");
		mouseCursorContainerText.className = "textest";
		mouseCursorContainerText.innerHTML = `
			<p>
				<b>SHOWREEL</b>
				<br />
				${this.currentTime}
			</p>
		`;

		const mouseCursorContainer = document.querySelector('.mf-cursor-text');

		if( mouseCursorContainer ) {
			mouseCursorContainer.prepend(mouseCursorContainerText);
		}
	}

	secondsToTime(secs) {
		secs = Math.round(secs);
		var hours = Math.floor(secs / (60 * 60));

		var divisor_for_minutes = secs % (60 * 60);
		var minutes = Math.floor(divisor_for_minutes / 60);

		var divisor_for_seconds = divisor_for_minutes % 60;
		var seconds = Math.ceil(divisor_for_seconds);

		var obj = {
			"h": hours,
			"m": '0' + minutes,
			"s": (seconds < 10 ? ('0' + seconds) : seconds )
		};
		return obj;
	}

	calculateDuration() {
		if( this.domVideoElem ) {
			this.domVideoElem.addEventListener('timeupdate', (e)=>{
				
				const time = this.secondsToTime(e.target.currentTime);
				this.currentTime = `${time.m}:${time.s}`;
				//console.info('VIDEO CURRENT TIME:', time);

				const timestamp = document.querySelector('.textest');
				if( timestamp ) {
					timestamp.innerHTML = `
						<p>
							<b>SHOWREEL</b>
							<br />
							${this.currentTime}
						</p>
					`;
				}
				//this.videoDuration = 0;
				//this.timeRemaining = 0;
			});
		}
	}

	fullscreenchangeHandler(event) {
		// document.fullscreenElement will point to the element that
		// is in fullscreen mode if there is one. If not, the value
		// of the property is null.
		if (document.fullscreenElement) {
			console.info(
				`Element: ${document.fullscreenElement.id} entered fullscreen mode.`,
			);
		} else {
			console.info("Leaving fullscreen mode.");

			//this.domVideoElem.muted = true;
			//this.domVideoElem.play();
		}
	}

	initMouseEvents() {

		const mediaQuery = window.matchMedia('(max-width: 1024px)');

		if( this.domVideoElem ) {

			

			if (mediaQuery.matches) {} else {
					
				this.calculateDuration();
				this.createVideoTextMouse();

			}

			this.domVideoElem.addEventListener("fullscreenchange", this.fullscreenchangeHandler);

			this.domVideoElem.addEventListener('click', async (e)=>{

				if (document.fullscreenElement) {
					await document.exitFullscreen();
					this.domVideoElem.muted = true;
					if (this.domVideoElem.paused) {
						this.domVideoElem.play();
					}

					if (mediaQuery.matches) {} else {
						this.domVideoElem.classList.add('no-cursor-override');
						this.domVideoMouse.setText('<span class="material-symbols-outlined">arrow_right</span>');
					}

					return;
				}

				this.domVideoElem.requestFullscreen()
					.then( async () => {

						//if (this.domVideoElem.paused) {
							//await this.domVideoElem.requestFullscreen();

							this.domVideoElem.muted = false;
							this.domVideoElem.play();
							
							//console.info('PLAYING VIDEO');

							if (mediaQuery.matches) {} else {
								this.domVideoElem.classList.remove('no-cursor-override');

								this.domVideoMouse.setText('<span class="material-symbols-outlined">pause</span>');
							}

							const slash = this.domElem.querySelector('.c-scene-slash');

							if( slash ) {

								gsap.to(slash,
									{
										maxWidth: '0%',
										scaleX: 1,
										autoAlpha: 0,
										backgroundColor: '#FECC00',
										overwrite: false,
										complete: () => {
											this.videoPlaying = true;
											this.domVideoElem.play();
											//console.info('PLAYING VIDEO');
											//jQuery('.c-scene-slash').remove();
										}
									},
								);

							}
						/*
						} else {
							//this.domVideoElem.pause();
							//console.info('VIDEO PAUSED');
							//await this.domVideoElem.requestFullscreen();
							this.domVideoElem.muted = false;

							this.domVideoElem.classList.add('no-cursor-override');

							this.domVideoMouse.setText('<span class="material-symbols-outlined">arrow_right</span>');

							//this.videoPlaying = false;
						}
						/**/
					})
					.catch((err) => {
						console.error(`Error enabling fullscreen: ${err.message}`);
					});

				
			})
		}

		if (mediaQuery.matches) {} else {

			this.domVideoContainer.addEventListener('mouseenter', (evt) => {
				evt.preventDefault();
				const target = evt.currentTarget;

				if( target ) {
					target.classList.add('no-cursor-override');
				}

				this.domVideoMouse.setText('<span class="material-symbols-outlined">arrow_right</span>'); 

				this.createVideoTextMouse();
			});

			this.domVideoContainer.addEventListener('mouseleave', (evt) => {
				evt.preventDefault();
				const target = evt.currentTarget;

				if( target ) {
					target.classList.remove('no-cursor-override');
				}

				this.domVideoMouse.removeText();
			});
		}
	}

}
